module.exports = __webpack_public_path__ + "img/D202311_3.6b429e73.jpg";